<script setup lang="ts">
import { useRouterStore } from '@/stores/router'
import { pinia } from '@/stores'
import AppButton from '@/components/ui/AppButton.vue'
import { onBeforeMount, ref } from 'vue'
import { getItem } from '@/services/item'
import { useRemoteDiagnose } from '@/stores/remote-diagnose'
import { storeToRefs } from 'pinia'
import ProductCard from '../ui/ProductCard.vue'
import IntroductionContent from '@/lang/introduction.json'
import { useLang } from '@/composables/use-lang'

const props = defineProps({
  aws_url: {
    type: String,
    required: true
  },
  erpnext_url: {
    type: String,
    required: true
  }
})

const { push } = useRouterStore(pinia)
const remoteDiagnoseStore = useRemoteDiagnose(pinia)
const { state } = storeToRefs(remoteDiagnoseStore)

const item = ref(null)
const error = ref<boolean>(false)
const langContent: any = useLang(IntroductionContent)

const next = () => {
  push('whatsapp')
}

onBeforeMount(async () => {
  const result = await getItem(state.value.item, props.aws_url)

  if (!result) {
    error.value = true
    return null
  }

  item.value = result
})
</script>

<template>
  <div v-if="langContent">
    <section>
      <product-card v-if="item" :item="item" :erpnext_url="erpnext_url" />

      <h2>{{ langContent.heading }}</h2>

      <p>{{ langContent.intro }}</p>

      <ul class="my-5">
        <li v-for="step in langContent.steps" :key="step">
          <p>{{ step }}</p>
        </li>
      </ul>

      <p class="mb-2.5">{{ langContent.pioneeringText }}</p>

      <p>{{ langContent.benefitsHeading }}</p>

      <ul class="my-5">
        <li v-for="benefit in langContent.benefits" :key="benefit">
          <p>{{ benefit }}</p>
        </li>
      </ul>
    </section>

    <p v-if="error" class="text-sweet-brown">{{ langContent.error }}</p>

    <div class="flex justify-center">
      <app-button @click="next">{{ langContent.button }}</app-button>
    </div>
  </div>
</template>

<style scoped></style>
